export default __webpack_public_path__ + "static/media/dualShock.78cb98d4.png";